import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-wa-navigation',
	templateUrl:'./WaNavigationPluginCompPage.html',
	styles: [],
	styleUrls:['./WaNavigationPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaNavigationPluginCompPage
{
	mdContent_1140 = `\`\`\`java
import com.jwebmp.webawesomepro.WaNavigation;
\`\`\``;
	mdContent_1141 = `\`\`\`java
new WaNavigation&lt;&gt;()
\`\`\``;
}
